export default {
    methods: {
        getCookie(name) {
            const regex = new RegExp(name + '=([^;]*)(;|$)')
            const matchedCookie = regex.exec(document.cookie)
            return (matchedCookie !== null && matchedCookie[1]) ? unescape(matchedCookie[1]) : null
        }

    }
}
